import { useEffect } from "react";

const SurveyRedirect = () => {
  useEffect(() => {
    window.parent &&
      window.parent.postMessage(
        {
          type: "survey",
          data: {
            "hs-formSubmitted": true,
          },
        },
        "*"
      );
  }, []);
  return <div>Thanks for your feedback! You can close this window now.</div>;
};

export default SurveyRedirect;
